import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API } from '@app-core/constants/api.constants';
import { AccessService } from '@app-core/services/access/access.service';
import { DataService } from '@app-core/services/data/data.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GeotabCredentials } from 'src/app/geotab/geotab-utils';
import { GeotabApiService } from '../geotab/geotab-api.service';

@Injectable({
  providedIn: 'root',
})
export class GeotabEulaService {
  private _isEULAAccepted: boolean | null = null;
  private credentials: GeotabCredentials;

  constructor(
    private httpClient: HttpClient,
    private accessService: AccessService,
    private dataService: DataService,
    private geotabApiService: GeotabApiService
  ) {
    this.credentials = this.geotabApiService.getGeotabCredentials();
    this.accessService.currentFleet = this.credentials.database;
    this.dataService.currentFleet = this.credentials.database;
  }

  public isEULAAccepted(): Observable<boolean> {
    if (typeof this._isEULAAccepted === 'boolean') return of(this._isEULAAccepted);

    const rideViewEULAStatus = JSON.parse(sessionStorage.getItem('rideview:EULA'));

    // eula credentials already exist for the user
    if (rideViewEULAStatus && rideViewEULAStatus[this.credentials.userName]) {
      this._isEULAAccepted = true;
      return of(this._isEULAAccepted);
    } else {
      return this.httpClient.get(API.EULA_CONSENT_2).pipe(
        map((res: any) => {
          this._isEULAAccepted = res?.data?.EULAConsent === 'ACCEPTED';
          if (this._isEULAAccepted) this.storeInBrowserStorage(true);
          return Boolean(this._isEULAAccepted);
        }),
        catchError(() => {
          this._isEULAAccepted = false;
          return of(this._isEULAAccepted);
        })
      );
    }
  }

  public declineEula() {
    // todo - redirect to dashboard
    this.storeInBrowserStorage(false);
  }

  public acceptEula(): Observable<boolean> {
    const body = {};
    return this.httpClient.post(API.EULA_CONSENT_2, body).pipe(
      map((res: any) => {
        this._isEULAAccepted = res?.data?.EULAConsent === 'ACCEPTED';
        if (this._isEULAAccepted) this.storeInBrowserStorage(true);
        return Boolean(this._isEULAAccepted);
      }),
      catchError(() => {
        this._isEULAAccepted = false;
        return of(this._isEULAAccepted);
      })
    );
  }

  private storeInBrowserStorage(eulaStatus: boolean) {
    const rideViewEULAStatus = JSON.parse(sessionStorage.getItem('rideview:EULA'));
    const data = {
      ...rideViewEULAStatus,
      [this.credentials.userName]: eulaStatus,
    };
    window.sessionStorage.setItem('rideview:EULA', JSON.stringify(data));
  }
}
